import axiosInstance from "../api/axiosInstance"

// GET: List users with pagination, filters, search
export const fetchUsers = (params) => axiosInstance.get("/admin/userList", { params });

// GET: Get single user details by ID
export const getUserById = (id) => axiosInstance.get(`/admin/userDetails/${id}`);

// PUT: Update user profile by ID
export const updateUser = (id, data) => axiosInstance.put(`/admin/updateUser/${id}`, data);

// PATCH: Ban or unban user
export const changeUserStatus = (id, data) => axiosInstance.patch(`/admin/banUser/${id}`, data);

export const changeUserVerificationStatus = (id, data) => axiosInstance.patch(`/admin/promoterVerifiedStatus/${id}`, data);

// DELETE: Soft delete a user
export const deleteUser = (id) => axiosInstance.delete(`/admin/deleteUser/${id}`);

// DELETE: Soft delete all user
export const deleteUserAll = (id) => {
  return axiosInstance.delete("/admin/deleteUserAll", {
    data: { id }, 
  });
};

